import styled from "styled-components";

import { LayoutStyledProps as Props } from "./Layout.types";

const LayoutStyled = styled.div<Props>`
  width: 100%;
  isolation: isolate;
  overflow-x: hidden !important;

  .Layout {
  }
`;

export default LayoutStyled;
